import React from "react";
import { Row, Col, Card } from "reactstrap";
import { Sparklines, SparklinesCurve } from "react-sparklines";
import CountUp from "react-countup";

const FiscalIndicator = ({ data, setFinantialRatio, setIsFirst }) => {
  return (
    <div>
      <div>
        <Row>
          <Col md="6" lg="6" xl="6">
            <div
              onClick={(e) => {
                setIsFirst(1);
                setFinantialRatio(
                  data.allAnnualData.edges.map(
                    (array) =>
                      array.node.socialSupportRevenueRatioMemberDonation
                  )
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer fiscalNameCard pointer">
                <div className="hatena">
                  ？{" "}
                  <p className="explaine">
                    年間の経常収益に占める会費と寄付金の割合です。自主財源として財務の安定性を示す指標の一つです。
                  </p>
                </div>
                <div className="widget-chart-content pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">寄付・会費率</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="fsize-4"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={
                              data.allAnnualData.edges.slice(-1)[0].node
                                .socialSupportRevenueRatioMemberDonation
                            }
                            separator=""
                            decimals={2}
                            decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={data.allAnnualData.edges.map(
                        (array) =>
                          array.node.socialSupportRevenueRatioMemberDonation
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          <Col md="6" lg="6" xl="6">
            <div
              onClick={(e) => {
                setIsFirst(1);
                setFinantialRatio(
                  data.allAnnualData.edges.map(
                    (array) => array.node.projectRevenueRatio
                  )
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer fiscalNameCard pointer">
                <div className="hatena">
                  ？{" "}
                  <p className="explaine">
                    年間の経常収益に占める自主・受託事業収入の割合です。比較的自由に使用できる財源ですが、市場での競争に晒される可能性が常に高いです。
                  </p>
                </div>
                <div className="widget-chart-content pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">事業収入比率</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="fsize-4"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={
                              data.allAnnualData.edges.slice(-1)[0].node
                                .projectRevenueRatio
                            }
                            separator=""
                            decimals={2}
                            decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={data.allAnnualData.edges.map(
                        (array) => array.node.projectRevenueRatio
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  data.allAnnualData.edges.map(
                    (array) =>
                      array.node
                        .socialSupportRevenueRatioMemberDonationSubsidies
                  )
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer fiscalNameCard pointer">
                <div className="hatena">
                  ？{" "}
                  <p className="explaine">
                    年間の経常収益に占める、会費と寄付金、補助金の割合です。社会からの資金支援の実態を見る一つの指標です。
                  </p>
                </div>
                <div className="widget-chart-content pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">社会的支援収入比率</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="fsize-4"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={
                              data.allAnnualData.edges.slice(-1)[0].node
                                .socialSupportRevenueRatioMemberDonationSubsidies
                            }
                            separator=""
                            decimals={2}
                            decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={data.allAnnualData.edges.map(
                        (array) =>
                          array.node
                            .socialSupportRevenueRatioMemberDonationSubsidies
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          <Col md="6" lg="6" xl="6">
            <div
              onClick={(e) => {
                setIsFirst(1);
                setFinantialRatio(
                  data.allAnnualData.edges.map((array) => array.node.hhi)
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer fiscalNameCard pointer">
                <div className="hatena">
                  ？{" "}
                  <p className="explaine">
                    収入源の多様性を表す指標です。収入多様性指標は１以下の正値をとり、その値が小さいほど収入源が多様化し、１に近いほど単独財源に集中しているを表します。
                  </p>
                </div>
                <div className="widget-chart-content pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">収入多様性指標</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="fsize-4"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={data.allAnnualData.edges.slice(-1)[0].node.hhi}
                            separator=""
                            decimals={2}
                            decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={data.allAnnualData.edges.map(
                        (array) => array.node.hhi
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  data.allAnnualData.edges.map(
                    (array) => array.node.administrativeExpenseRatio
                  )
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-warning"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer fiscalNameCard pointer">
                <div className="hatena">
                  ？{" "}
                  <p className="explaine">
                    年間の経常費用の内、管理費（人件費・その他）に占める割合で、財務の効率性を表します。
                  </p>
                </div>
                <div className="widget-chart-content pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">管理費比率</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="fsize-4"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={
                              data.allAnnualData.edges.slice(-1)[0].node
                                .administrativeExpenseRatio
                            }
                            separator=""
                            decimals={2}
                            decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={data.allAnnualData.edges.map(
                        (array) => array.node.administrativeExpenseRatio
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  data.allAnnualData.edges.map(
                    (array) => array.node.payablePeriod
                  )
                );
                // refetch();
                // setChart(
                //   <BarChart
                //     financialRatio={financialRatio}
                //     fiscalYearData={fiscalYearData}
                //   />
                // );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer fiscalNameCard pointer">
                <div className="hatena">
                  ？{" "}
                  <p className="explaine">
                    新規収入がなく、現在手元にある資金で、現在の事業をどれくらいの期間維持ができるか、財務の短期的な流動性と持続性を表します。
                  </p>
                </div>
                <div className="widget-chart-content pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">支払可能期間（ヵ月）</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="fsize-4"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={
                              data.allAnnualData.edges.slice(-1)[0].node
                                .payablePeriod
                            }
                            separator=""
                            decimals={2}
                            decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={data.allAnnualData.edges.map(
                        (array) => array.node.payablePeriod
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  data.allAnnualData.edges.map(
                    (array) => array.node.revenueRatio
                  )
                );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-primary"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer fiscalNameCard pointer">
                <div className="hatena">
                  ？{" "}
                  <p className="explaine">
                    収入の内、留保できる資金の比率を示し、財務の収益性を表します。
                  </p>
                </div>
                <div className="widget-chart-content pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">収益率</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="fsize-4"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={
                              data.allAnnualData.edges.slice(-1)[0].node
                                .revenueRatio
                            }
                            separator=""
                            decimals={2}
                            decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={data.allAnnualData.edges.map(
                        (array) => array.node.revenueRatio
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col md="6" lg="6" xl="6">
            <div
              onClick={() => {
                setIsFirst(1);
                setFinantialRatio(
                  data.allAnnualData.edges.map(
                    (array) => array.node.ratioNetAssetsRevenue
                  )
                );
              }}
              className="card mb-2 widget-chart widget-chart2 text-left card-btm-border card-shadow-success"
              style={{ borderColor: "#44CAE1" }}
            >
              <div className="widget-chat-wrapper-outer fiscalNameCard pointer">
                <div className="hatena">
                  ？{" "}
                  <p className="explaine">
                    収入の内、どの程度の内部留保を蓄積しているかを示し、財務の中長期的な持続性を表します。
                  </p>
                </div>

                <div className="widget-chart-content pt-3 pl-3 pb-1">
                  <h6 className="widget-heading mb-0">正味財産・収益比率</h6>
                  <div className="widget-chart-flex">
                    <div className="widget-numbers">
                      <div className="widget-chart-flex">
                        <div
                          className="fsize-4"
                          style={{
                            marginTop: -10,
                            fontWeight: "bold",
                          }}
                        >
                          <CountUp
                            start={0}
                            end={
                              data.allAnnualData.edges.slice(-1)[0].node
                                .ratioNetAssetsRevenue
                            }
                            separator=""
                            decimals={2}
                            decimal="."
                            prefix=""
                            duration="10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="no-gutters widget-chart-wrapper mt-2 mb-2 pl-2 he-auto">
                  <Col md="9">
                    <Sparklines
                      data={data.allAnnualData.edges.map(
                        (array) => array.node.ratioNetAssetsRevenue
                      )}
                    >
                      <SparklinesCurve
                        style={{
                          strokeWidth: 3,
                          stroke: "#44CAE1",
                          fill: "none",
                        }}
                      />
                    </Sparklines>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default FiscalIndicator;
